import React from 'react'
import './index.scss'
import { useLocation } from 'react-router-dom'
import { ReactComponent as ArrowLeft } from '../../assets/icons/arrows.svg'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { MESSAGE_BACK_TO_HOME_MINI_APP, PARAM_IFRAME_HEADER_TITLE } from '../../constants/params'
import { smartParseParam } from '../../helper/UrlParamsHelper'
import { checkIsBackToHomeMiniApp } from '../../helper/checkIsEmbeddedView'
import { useAppParamsContext } from '../../context/AppParamsContext'

export default function Header({ title, onBack }) {
  const location = useLocation()
  const searchparam = location.search
  const params = new URLSearchParams(searchparam)
  const headerTitle = smartParseParam(params.get(PARAM_IFRAME_HEADER_TITLE)) || 'Thông tin lịch hẹn'
  const history = useHistory()
  const { isHeaderMiniAppExpand } = useAppParamsContext()

  const isBackToHomeMiniApp = checkIsBackToHomeMiniApp(window.location.href)
  return (
    <div className={`Header ${isHeaderMiniAppExpand ? 'Header_expand' : ''}`}>
      <div className="Header_fixed">
        <ArrowLeft
          onClick={() => {
            if (isBackToHomeMiniApp) {
              if (window.parent) {
                window.parent.postMessage({ key: MESSAGE_BACK_TO_HOME_MINI_APP }, '*')
              }
              return
            }
            if (onBack) {
              onBack()
            } else {
              history.goBack()
            }
          }}
        />
        <span>{title || headerTitle || ''}</span>
        <div className="no_icon"></div>
      </div>
      <div className="Header_padding"></div>
    </div>
  )
}
